import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { RootState } from '../app/store';
import { plugAndPlayConfig } from '../config/plugAndPlay';
import { User } from '../pages/UserProfile/userProfileSlice';

export default function useProjectUsers(): User[] {
  // Legacy users from Project Register
  const { users: projectRegisterUsers } = useSelector(
    (state: RootState) => state.projectRegisters
  );

  // Plug and Play users from project-specific API
  const { data: projectUsers } = useSelector(
    (state: RootState) => state.projectUsers
  );

  // Environment-based user selection
  const users: User[] = useMemo(() => {
    if (plugAndPlayConfig.isEnabled) {
      return projectUsers || [];
    }
    return projectRegisterUsers || [];
  }, [projectUsers, projectRegisterUsers]);

  return users;
}